import * as React from 'react';
import { Spinner as ShadcnSpinner } from '@/hen-ui/shadcn/spinner';
import { cn } from '@/hen-ui/utils';

export type SpinnerProps = React.ComponentProps<'svg'> & {
  /** Accessible loading message for screen readers (default: "Loading...") */
  label?: string;
};

export const Spinner: React.FC<SpinnerProps> = ({
  className,
  label = 'Loading...',
  ...props
}) => (
  <ShadcnSpinner
    className={cn(
      'text-neutral-black animate-spin motion-reduce:animate-none',
      className,
    )}
    role='status'
    aria-live='polite'
    aria-label={label ?? props['aria-label']}
    {...props}
  />
);
